import Logo from "./Logo";
import Menu from "./Menu";
import Burger from "./Burger";
import classNames from "classnames";
import styles from "./Nav.module.css";
import { useIsScrollingDown } from "../utils/hooks";
import { useState, useEffect } from "react";

export default function Nav({ pathName }) {
  const isScrollingDown = useIsScrollingDown();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "visible";
  }, [isMenuOpen, setIsMenuOpen]);

  return (
    <>
      <header
        className={classNames({
          [styles.Nav]: true,
          [styles.retracted]: !isScrollingDown,
          [styles.active]: isMenuOpen,
        })}
      >
        <Logo isMenuOpen={isMenuOpen} />
        <Menu isMenuOpen={isMenuOpen} pathName={pathName} />
      </header>
      <Burger retracted={!isScrollingDown} setIsMenuOpen={setIsMenuOpen} />
    </>
  );
}
